const parseEmbedUrl = (url: string) => {
  // - Supported YouTube URL formats:
  //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
  //   - http://youtu.be/My2FRPA3Gf8
  //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
  // - Supported Vimeo URL formats:
  //   - http://vimeo.com/25451551
  //   - http://player.vimeo.com/video/25451551
  // - Also supports relative URLs:
  //   - //player.vimeo.com/video/25451551

  url.match(/(http:\/\/|https:\/\/|)(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/);
  let mime;

  if (RegExp.$3.indexOf('youtu') > -1) {
    mime = 'video/youtube';
  } else if (RegExp.$3.indexOf('vimeo') > -1) {
    mime = 'video/vimeo';
  }

  return {
    mime,
  };
};

export default parseEmbedUrl;
